var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.25H0.25V5.5H1.75V1.75H5.5V0.25Z",
    fill: "#E8EBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 0.25H26.5V1.75H30.25V5.5H31.75V0.25Z",
    fill: "#E8EBF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 26.5V30.25H5.5V31.75H0.25V26.5H1.75Z",
    fill: "#E8EBF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 31.75V26.5H30.25V30.25H26.5V31.75H31.75Z",
    fill: "#E8EBF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0729 24.1887C12.3614 24.5882 12.9563 24.5882 13.2448 24.1887L18.0475 17.5388C21.2223 13.143 18.0813 7 12.6589 7C7.2364 7 4.09543 13.143 7.27022 17.5388L12.0729 24.1887ZM12.6589 15.5C13.7635 15.5 14.6589 14.6046 14.6589 13.5C14.6589 12.3954 13.7635 11.5 12.6589 11.5C11.5544 11.5 10.6589 12.3954 10.6589 13.5C10.6589 14.6046 11.5544 15.5 12.6589 15.5Z",
    fill: "#E8EBF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4868 18.0924L22.0999 21.7918C22.2959 22.0694 22.7039 22.0694 22.9 21.7918L26.1553 17.183C28.279 14.1764 26.1536 10 22.4999 10C21.6454 10 20.8746 10.2284 20.2221 10.6168C21.1601 12.9433 21.0523 15.7037 19.4868 18.0924Z",
    fill: "#E8EBF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounds);
export default __webpack_public_path__ + "static/media/bounds.ac3ee2b37c1d6ee6267f7149a306bd7a.svg";
export { ForwardRef as ReactComponent };